import React, {Fragment} from "react";
import CommonHeader from "../../components/Headers/CommonHeader";
import ProtectedContent from "../../components/protectedContent";
import SafeView from "../../components/safeView/SafeView";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import WebhookModal from "./webhookModal";
import WebhooksTable from "./webhooksTable";

const WebhooksComponent = () => {
  const {
    isOpen: isWebhookModalOpen,
    onOpen: openWebhookModal,
    onClose: closeWebhookModal,
  } = useDisclosure();

  return (
    <SafeView>
      <ProtectedContent perms={["view_webhook"]} showFallback>
        <Fragment>
          {isWebhookModalOpen && (
            <WebhookModal open={isWebhookModalOpen} onCancel={closeWebhookModal} />
          )}
          <ProtectedContent perms={["add_webhook"]}>
            <CommonHeader
              content={"Add Webhook"}
              handleAddClick={openWebhookModal}
              testID={"add_webhook"}
            />
          </ProtectedContent>
          <WebhooksTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const WebhooksPage = () => {
  return (
    <PageURLContextProvider>
      <WebhooksComponent />
    </PageURLContextProvider>
  );
};

export default WebhooksPage;
